import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { ArchivePageData, LocationsList, StaffMembers } from '@core/models';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginator } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-archive-page',
  templateUrl: './archive-page.component.html',
  styleUrls: ['./archive-page.component.scss'],
  imports: [
    RouterLink,
    MatButtonModule,
    MatTableModule,
    NgClass,
    MatCheckboxModule,
    MatSortModule,
    MatTableModule,
    MatIconModule,
  ],
})
export class ArchivePageComponent implements OnInit {
  @Input() displayedOptions;
  @Input() tableStructure = [];
  @Input() notEmpty = false;
  @Input() showData = false;
  @Input() pageData: ArchivePageData;
  @Output() makeActive: EventEmitter<LocationsList[] | StaffMembers[]> =
    new EventEmitter<LocationsList[] | StaffMembers[]>();
  dataSource: MatTableDataSource<
    StaffMembers[] | LocationsList[],
    MatPaginator
  > = new MatTableDataSource([]);
  selection = new SelectionModel(true, []);

  constructor() {}

  @Input('tableData') set tableData(data) {
    if (!data) {
      return;
    }
    this.dataSource = new MatTableDataSource(data);
    this.selection.clear();
  }

  ngOnInit(): void {}

  public toggleAllRows(): void {}

  public isAllSelected(): boolean {
    return false;
  }

  public checkboxLabel(row?: StaffMembers): string {
    return '';
  }
}
